import { DataAccess } from "../dataaccess/data.access";

export class PasswordRemindService {
    public static remind(username: string) {
        return DataAccess.post(
            DataAccess.injectCaller("/r25user/remind.json?r25_username=" + username, "PasswordRemindService.remind"),
        );
    }
}
